import styled from 'styled-components'

const FormAbout = styled.form`
  display: grid; 
  grid-template-columns: 1fr 3fr; 
  grid-gap: 20px; 
`; 

export default FormAbout